export default "__VITE_ASSET__CBG$CuXq__"